<template>
  <v-container fluid>
    <v-row>
      <v-col
        sm="6"
        lg="7"
        xl="8"
      >
        <GmapMap
          ref="sharerMap"
          :center="centerMap"
          :options="optionsMap"
          :zoom="zoomMap"
          map-type-id="terrain"
          class="status-map"
          @click="isInfoShown = false"
        >
          <GmapMarker
            v-for="(marker, index) in playerList"
            :key="index"
            :position="marker.position"
            :clickable="true"
            :draggable="false"
            :icon="{ url: url(marker.problems) }"
            :title="marker.name"
            @click="marker.isInfoShown = clickInfo(marker)"
          >
            <GmapInfoWindow
              :opened="marker.isInfoShown"
              :options="{
                content:
                  '<span class=\'iconTitle\'></span>' +
                  '<span> </span>' +
                  '<span class=\'icon\'>' +
                  marker.name +
                  '</span>' +
                  '<br/><br/>' +
                  '<span class=\'iconNetwork\'></span>' +
                  '<span style=\'color:black\'> ' +
                  $t('status.last-connection') +
                  ' : ' +
                  marker.lastConnection +
                  '</span>' +
                  '<br/><br/>' +
                  '<span class=\'iconUpdate\'></span>' +
                  '<span style=\'color:black\'> ' +
                  $t('status.last-update') +
                  ' : ' +
                  marker.lastUpdate +
                  '</span>',
              }"
              @closeclick="marker.isInfoShown = false"
            />
          </GmapMarker>
        </GmapMap>
      </v-col>
      <v-col
        sm="6"
        lg="5"
        xl="4"
      >
        <players-and-problem-container
          v-if="dataLoaded"
          :player-connected="playerConnected"
          :player-disconnected="playerDisconnected"
          :player-problems="playerProblems"
          :player-no-response="playerNoResponse"
          @itemSelected="selectMarker"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Components
import playersAndProblemContainer from "./StatusPage/PlayersAndProblemContainer";

// Connectors
import { PlayerConnector } from "./Database/PlayerConnector";

// Tools
import { gmapApi } from "vue2-google-maps";

export default {
  components: {
    playersAndProblemContainer,
  },
  data() {
    return {
      playerConnector: new PlayerConnector(this.$store.state.user),
      dataLoaded: false,
      playerConnected: [],
      playerDisconnected: [],
      playerProblems: [],
      playerNoResponse: [],
      playerList: [],
      bounds: null,
      centerMap: {
        lat: 47.0,
        lng: 2.0,
      },
      optionsMap: {
        disableDefaultUi: true,
        fullscreenControl: false,
        mapTypeControl: false,
        rotateControl: false,
        scaleControl: false,
        streetViewControl: false,
        zoomControl: false,
      },
      zoomMap: 6,
    };
  },
  computed: {
    google: gmapApi,
  },
  created() {
    document.title = this.$t("navbar.status") + " · " + this.$t("appname");
    this.$store.dispatch("setHeader", this.$t("navbar.status"));
  },
  mounted() {
    if (this.$store.state.user.socId != null) {
      // API CALLS
      this.getAllPlayers()
        .then((listPlayer) => {
          this.playerList = listPlayer;
          this.formatDate();

          this.dataLoaded = true;
          this.initMaps();
        })
        .catch((err) => {
          console.error(err);
        });
    }
  },
  methods: {
    selectMarker(item) {
      this.playerList.forEach((player) => {
        if (item.length > 0) {
          if (player.name == item[0].name) {
            player.isInfoShown = true;
          } else {
            player.isInfoShown = false;
          }
        } else {
          player.isInfoShown = false;
        }
      });
    },
    clickInfo(marker) {
      if (marker !== undefined) {
        this.$emit("update:selectedPlayerComputed", marker);
        if (marker.isInfoShown !== undefined) {
          for (let i = 0; i < this.playerList.length; i++) {
            if (marker.id != this.playerList[i].id) {
              this.playerList[i].isInfoShown = false;
            }
          }
          return !marker.isInfoShown;
        }
      }
    },
    url(problem) {
      if (problem !== undefined) {
        if (problem.length > 0) {
          if (problem[0].name == "technical") {
            return require("../assets/icon/technical.png");
          } else if (problem[0].name == "network") {
            return require("../assets/icon/error.png");
          } else if (problem[0].name == "no-response") {
            return require("../assets/icon/noresponse.png");
          } else if (problem[0].name == "connected") {
            return require("../assets/icon/check.png");
          }
        }
      }

      return "";
    },
    getAllPlayers() {
      return new Promise((resolve, reject) => {
        // TODO: Make DB route to return all infos in one shot
        Promise.all([this.getAllConnected(), this.getAllDisconnected(), this.getAllProblems(), this.getAllNoResponse()])
          .then((results) => {
            // SAVE CONNECTED TO SEND IN PROPS FOR PLAYERS AND PROBLEM
            this.playerConnected = results[0];
            this.playerDisconnected = results[1];
            this.playerProblems = results[2];
            this.playerNoResponse = results[3];

            let listPlayers = [];
            if (results.length == 4) {
              listPlayers = listPlayers.concat(
                this.playerConnected,
                this.playerDisconnected,
                this.playerProblems,
                this.playerNoResponse
              );
            }

            // REMOVE DUPLICATES AND CONCAT ERRORS
            for (let i = 0; i < listPlayers.length; i++) {
              for (let j = i + 1; j < listPlayers.length; j++) {
                if (listPlayers[i].id == listPlayers[j].id) {
                  listPlayers[i].problems = listPlayers[i].problems.concat(listPlayers[j].problems);
                  listPlayers.splice(j, 1);
                  j = j - 1;
                }
              }
            }

            return resolve(listPlayers);
          })
          .catch((err) => {
            return reject(err);
          });
      });
    },
    getAllConnected() {
      return new Promise((resolve, reject) => {
        this.playerConnector
          .getAllPlayersNetworkConnect()
          .then((players) => {
            // TODO: format in db server
            const listConnected = players.map((element) => {
              return {
                id: element.id_plyr,
                name: element.name,
                position: {
                  lat: parseFloat(element.lat),
                  lng: parseFloat(element.lng),
                },
                isInfoShown: false,
                lastUpdate: element.last_update,
                lastConnection: element.last_connect,
                problems: [
                  {
                    name: "connected",
                    icon: "map-marker-check",
                  },
                ],
              };
            });

            return resolve(listConnected);
          })
          .catch((err) => {
            return reject(err);
          });
      });
    },
    getAllDisconnected() {
      return new Promise((resolve, reject) => {
        this.playerConnector
          .getAllPlayersNetworkDisconnect()
          .then((players) => {
            // TODO: format in db server
            const listDisconnected = players.map((element) => {
              return {
                id: element.id_plyr,
                name: element.name,
                position: {
                  lat: parseFloat(element.lat),
                  lng: parseFloat(element.lng),
                },
                isInfoShown: false,
                lastUpdate: element.last_update,
                lastConnection: element.last_connect,
                problems: [
                  {
                    name: "network",
                    icon: "close-network",
                  },
                ],
              };
            });

            return resolve(listDisconnected);
          })
          .catch((err) => {
            return reject(err);
          });
      });
    },
    getAllProblems() {
      return new Promise((resolve, reject) => {
        this.playerConnector
          .getAllPlayersNetworkProblemTechni()
          .then((players) => {
            // TODO: format in db server
            const listProblem = players.map((element) => {
              return {
                id: element.id_plyr,
                name: element.name,
                position: {
                  lat: parseFloat(element.lat),
                  lng: parseFloat(element.lng),
                },
                isInfoShown: false,
                lastUpdate: element.last_update,
                lastConnection: element.last_connect,
                problems: [
                  {
                    name: "technical",
                    icon: "alert",
                  },
                ],
              };
            });

            return resolve(listProblem);
          })
          .catch((err) => {
            return reject(err);
          });
      });
    },
    getAllNoResponse() {
      return new Promise((resolve, reject) => {
        this.playerConnector
          .getAllPlayersNetworkNoResponse()
          .then((players) => {
            // TODO: format in db server
            const listNoResponse = players.map((element) => {
              return {
                id: element.id_plyr,
                name: element.name,
                position: {
                  lat: parseFloat(element.lat),
                  lng: parseFloat(element.lng),
                },
                isInfoShown: false,
                lastUpdate: element.last_update,
                lastConnection: element.last_connect,
                problems: [
                  {
                    name: "no-response",
                    icon: "message-bulleted-off",
                  },
                ],
              };
            });

            return resolve(listNoResponse);
          })
          .catch((err) => {
            return reject(err);
          });
      });
    },
    initMaps() {
      this.$gmapApiPromiseLazy().then(() => {
        this.bounds = new this.google.maps.LatLngBounds();

        this.playerList.forEach((element) => {
          this.bounds.extend({
            lat: parseFloat(element.position.lat),
            lng: parseFloat(element.position.lng),
          });
        });

        this.$refs.sharerMap.panToBounds(this.bounds);
        this.autoZoom();
      });
    },
    formatDate() {
      for (let i = 0; i < this.playerList.length; i++) {
        this.playerList[i].lastUpdate = this.playerList[i].lastUpdate.replace("00:00", "");
        this.playerList[i].lastUpdate = this.playerList[i].lastUpdate.replace("00/00/0000", "");
        this.playerList[i].lastConnection = this.playerList[i].lastConnection.replace("00:00", "");
        this.playerList[i].lastConnection = this.playerList[i].lastConnection.replace("00/00/0000", "");
      }
    },
    autoZoom() {
      if (this.bounds) {
        this.$refs.sharerMap.fitBounds(this.bounds);
      }
    },
  },
};
</script>

<style>
.icon {
  color: black;
  font-size: 20px;
  font-weight: bold;
}

.iconTitle:before {
  content: "";
  width: 1.5em;
  height: 1.5em;
  margin-right: 0.2em;
  display: inline-block;
  background-size: cover;
  background-image: url("../assets/icon/tag.png");
}

.iconNetwork:before {
  content: "";
  width: 1.5em;
  height: 1.5em;
  margin-right: 0.2em;
  display: inline-block;
  background-size: cover;
  background-image: url("../assets/icon/check-network.png");
}

.iconUpdate:before {
  content: "";
  width: 1.5em;
  height: 1.5em;
  margin-right: 0.2em;
  display: inline-block;
  background-size: cover;
  background-image: url("../assets/icon/update.png");
}

.status-map {
  width: 100%;
  height: 100%;
}
</style>
